import { apiSlice } from '../../app/services/apiSlice';
import StyledImage from '../../app/components/styledComponents/StyledImage';
import {
  resetProductsState,
  setProductsProgress,
} from '../../app/services/products';

import { S3Client } from '@aws-sdk/client-s3';
import { Upload } from '@aws-sdk/lib-storage';
import { XhrHttpHandler } from '@aws-sdk/xhr-http-handler';
import store from '../../app/store';
import { checkImageURL, generateUploadFileName, uuidv4 } from '../../utils/helper';
import axios from 'axios';

const NEW_PRODUCTS_URL ='inventory/inventory/v2';
const PRODUCTS_URL = 'inventory/inventory';
const INVENTORY_URL = 'inventory/api/floristInventory';
const FLORIST_INVENTORY = 'inventory/api/floristInventory';
const INVENTORY_INSIGHTS = 'inventory/api/florist/inventory';
const APIV2 ='/v2';
const FLORIST_INVENTORY_Drawer = 'inventory/api/floristInventory/drawer';

export const productsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    addProduct: builder.mutation({
      queryFn: async ({ values }, _api, _extraOptions, baseQuery) => {
        try {
          const progresses = [];
          let data = { ...values };

          const s3 = new S3Client({
          region: process.env.REACT_APP_S3_BUCKET_REGION,
          requestHandler: new XhrHttpHandler({}),
        });

          if (!data?.id) {
            const response = await baseQuery({
              url: `${PRODUCTS_URL}`,
              method: 'POST',
              body: {
                ...data,
                inventoryImages: [],
                variationDTOS: data.floristVariationDTOS?.map((item) => ({
                  ...item,
                  imageDTOList: [],
                })),
              },
            });
            data = {
              ...data,
              id: response?.data?.objectData?.id,
            };
          }
          const updatedImagesPromise = data?.inventoryImages?.length
            ? Promise.all(
                data?.inventoryImages?.map(async (image, index) => {
                  if (image.file) {
                    try {
                      const newFileName = generateUploadFileName(image.file);
                      const imagePath = `inventory-products/${
                        data.id ? `${data.id}/` : ''
                      }${newFileName}`;
                      const params = {
                        Bucket: process.env.REACT_APP_S3_BUCKET_UPLOAD_URL,
                        Key: imagePath,
                        Body: image.file,
                      };

                      const upload = new Upload({
                        client: s3,
                        params,
                      });

                      upload.on('httpUploadProgress', (progress) => {
                        const currentProgress = parseInt(
                          (progress.loaded * 100) / progress.total,
                        );
                        progresses?.splice(index, 1, currentProgress);
                        const sumProgresses =
                          progresses.reduce((a, b) => a + b, 0) ?? 100;
                        const progressesLength = progresses?.length ?? 1;
                        const calculatedProgress = parseInt(
                          sumProgresses / progressesLength,
                        );
                        store.dispatch(
                          setProductsProgress({
                            progress: calculatedProgress,
                            isFlorist: false,
                          }),
                        );
                      });

                      await upload.done();

                      const s3BucketUrl = `https://${process.env.REACT_APP_S3_BUCKET_URL}/${imagePath}`;
                      const updatedImage = {
                        ...image,
                        url: s3BucketUrl,
                      };
                      delete updatedImage.file;
                      return updatedImage;
                    } catch (error) {}
                  } else {
                    progresses.splice(index, 1, 100);
                    return image;
                  }
                }),
              )
            : [];
          const updatedVariationsPromise = data.variationDTOS?.length
            ? Promise.all(
                data.variationDTOS?.map(async (variation) => {
                  return new Promise(async (resolve) => {
                    const updatedImages = variation?.imageDTOList?.length
                      ? await Promise.all(
                          variation?.imageDTOList?.map(async (image, index) => {
                            if (image.file) {
                              try {
                                const newFileName = generateUploadFileName(
                                  image.file,
                                );
                                const imagePath = `inventory-products/${
                                  data.id ? `${data.id}/` : ''
                                }${newFileName}`;
                                const params = {
                                  Bucket:
                                    process.env.REACT_APP_S3_BUCKET_UPLOAD_URL,
                                  Key: imagePath,
                                  Body: image.file,
                                };
                                const upload = new Upload({
                                  client: s3,
                                  params,
                                });

                                upload.on('httpUploadProgress', (progress) => {
                                  const currentProgress = parseInt(
                                    (progress.loaded * 100) / progress.total,
                                  );
                                  progresses?.splice(index, 1, currentProgress);
                                  const sumProgresses =
                                    progresses.reduce((a, b) => a + b, 0) ??
                                    100;
                                  const progressesLength =
                                    progresses?.length ?? 1;
                                  const calculatedProgress = parseInt(
                                    sumProgresses / progressesLength,
                                  );
                                  store.dispatch(
                                    setProductsProgress({
                                      progress: calculatedProgress,
                                      isFlorist: false,
                                    }),
                                  );
                                });

                                await upload.done();

                                const s3BucketUrl = `https://${process.env.REACT_APP_S3_BUCKET_URL}/${imagePath}`;
                                const updatedImage = {
                                  ...image,
                                  url: s3BucketUrl,
                                };
                                delete updatedImage.file;
                                return updatedImage;
                              } catch (error) {}
                            } else {
                              progresses.splice(index, 1, 100);
                              return image;
                            }
                          }),
                        )
                      : [];
                    resolve({ ...variation, imageDTOList: updatedImages });
                  });
                }),
              )
            : [];
          const [updatedImages, updatedVariations] = await Promise.all([
            updatedImagesPromise,
            updatedVariationsPromise,
          ]);
          data.inventoryImages = updatedImages;
          data.variationDTOS = updatedVariations;
          const response = await baseQuery({
            url: `${PRODUCTS_URL}`,
            method: 'POST',
            body: { ...data },
          });

          store.dispatch(
            setProductsProgress({
              uploading: false,
              isFlorist: false,
            }),
          );
          store.dispatch(resetProductsState());
          return { data: response.data?.objectData };
        } catch (error) {
          return { error };
        }
      },
      invalidatesTags: ['preLiveChecks'],
    }),
    getProductsDropDown: builder.mutation({
      query: (params) => ({
        url: `${PRODUCTS_URL}`,
        params: { ...params },
      }),
      transformResponse: (responseData) => {
        responseData.options = responseData?.objectData?.content?.map(
          (product) => {
            let thumbImage = product?.inventoryImages?.find(
              (i) => i?.thumbnail,
            );
            thumbImage = thumbImage?.url ? (
              <StyledImage size="25px" className="rounded-1 m-0 ">
                <img
                  loading="lazy"
                  src={thumbImage?.url}
                  alt={product?.fileName || ''}
                />
              </StyledImage>
            ) : (
              <></>
            );

            return {
              ...product,
              id: product.id,
              title: (
                <div className="d-flex align-items-center gap-2">
                  {thumbImage} <h5 className="mt-2">{product.itemName}</h5>
                </div>
              ),
            };
          },
        );
        return responseData || {};
      },
    }),
    getProducts: builder.query({
      query: (params) => ({
        url: NEW_PRODUCTS_URL,
        params,
      }),
    }),
    deleteProduct: builder.mutation({
      query: (id) => ({
        url: `${PRODUCTS_URL}/${id}`,
        method: 'DELETE',
      }),
    }),
    deleteBulkProduct: builder.mutation({
      query: (data) => ({
        url: `${PRODUCTS_URL}/deleteByIds`,
        body: { deleteIds: [...data] },
        method: 'DELETE',
      }),
    }),
    getSingleProduct: builder.query({
      query: (id) => ({
        url: `${PRODUCTS_URL}/${id}`,
      }),
    }),
    getSingleProductById: builder.mutation({
      query: (id) => ({
        url: `${PRODUCTS_URL}/${id}`,
        method: 'GET',
      }),
    }),
    addCatalogue: builder.mutation({
      query: (data) => ({
        url: `${INVENTORY_URL}/createFromInventory`,
        method: 'POST',
        body: { inventoryDTOS: [...data] },
      }),
    }),
    getFloristInventory: builder.query({
      query: (params) => ({
        url: `${FLORIST_INVENTORY}${APIV2}`,
        params,
      }),
    }),
    addFloristInventory: builder.mutation({
      queryFn: async ({ values, uuid }, _api, _extraOptions, baseQuery) => {
        try {
          const progresses = [];
          let data = { ...values };

          const s3 = new S3Client({
            region: process.env.REACT_APP_S3_BUCKET_REGION,
            requestHandler: new XhrHttpHandler({}),
          });

          if (!data?.id) {
            const response = await baseQuery({
              url: `${FLORIST_INVENTORY}`,
              method: 'POST',
              body: {
                ...data,
                floristInventoryImages: [],
                floristVariationDTOS: data.floristVariationDTOS?.map(
                  (item) => ({ ...item, imageDTOList: [] }),
                ),
              },
            });
            data = {
              ...data,
              id: response?.data?.objectData?.id,
            };
          }
          const updatedImagesPromise = data?.floristInventoryImages?.length
            ? Promise.all(
                data?.floristInventoryImages?.map(async (image, index) => {
                  if (image.file) {
                    try {
                      const extension = image?.file?.name?.split('.').pop();
                      const newFileName = `${uuidv4()}.${extension}`;

                      const imagePath = `image-gallery/${
                        uuid ? `${uuid}/` : ''
                      }${data.id ? `${data.id}/` : ''}${newFileName}`;

                      const preSignedUrlPayload = {
                        bucketName: process.env.REACT_APP_S3_BUCKET_UPLOAD_URL,
                        path: imagePath,
                        contentType: image?.file?.type,
                      };

                      const response = await baseQuery({
                        url: `vendor/api/floristImages/generatePresignedUrl`,
                        method: 'POST',
                        body: { ...preSignedUrlPayload },
                      });

                      const presignedUrl = response?.error?.data
                        .replace(/^Presigned URL:\s*/, '')
                        .trim();

                      const fileBuffer = await image.file.arrayBuffer();

                      await axios.put(presignedUrl, fileBuffer, {
                        headers: {
                          'Content-Type': image?.file?.type,
                        },
                        onUploadProgress: (progressEvent) => {
                          const { loaded, total } = progressEvent;
                          const currentProgress = parseInt((loaded * 100) / (total ?? 1));
                      
                          store.dispatch(
                            setProductsProgress({
                              progress: currentProgress,
                              isFlorist: data.isFlorist,
                            }),
                          );
                        },
                      });
                      
                      const s3BucketUrl = `https://${process.env.REACT_APP_S3_BUCKET_URL}/${imagePath}`;
                      await checkImageURL(s3BucketUrl);
                      const updatedImage = {
                        ...image,    
                        url: s3BucketUrl,
                      };
                      delete updatedImage.file;
                      return updatedImage;
                    } catch (error) {}
                  } else {
                    progresses.splice(index, 1, 100);
                    return image;
                  }
                }),
              )
            : [];
          const updatedVariationsPromise = data.floristVariationDTOS?.length
            ? Promise.all(
                data.floristVariationDTOS?.map(async (variation) => {
                  return new Promise(async (resolve) => {
                    const updatedImages = variation?.imageDTOList?.length
                      ? await Promise.all(
                          variation?.imageDTOList?.map(async (image, index) => {
                            if (image.file) {
                              try {
                                const extension = image?.file?.name
                                  ?.split('.')
                                  .pop();
                                const newFileName = `${uuidv4()}.${extension}`;

                                const imagePath = `image-gallery/${
                                  uuid ? `${uuid}/` : ''
                                }${data.id ? `${data.id}/` : ''}${newFileName}`;

                                const preSignedUrlPayload = {
                                  bucketName: process.env.REACT_APP_S3_BUCKET_UPLOAD_URL,
                                  path: imagePath,
                                  contentType: image?.file?.type,
                                };    
                                
                                const response = await baseQuery({
                                  url: `vendor/api/floristImages/generatePresignedUrl`,
                                  method: 'POST',
                                  body: { ...preSignedUrlPayload },
                                });

                                const presignedUrl = response?.error?.data
                                  .replace(/^Presigned URL:\s*/, '')
                                  .trim();

                                const fileBuffer =
                                  await image.file.arrayBuffer();

                                  await axios.put(presignedUrl, fileBuffer ,  {
                                    headers: {
                                      'Content-Type': image?.file?.type,
                                    },
                                    onUploadProgress: (progressEvent) => {
                                      const { loaded, total } = progressEvent;
                                      const currentProgress = parseInt((loaded * 100) / (total ?? 1));

                                      console.log(currentProgress , 'currentProgress')
                                  
                                      store.dispatch(
                                        setProductsProgress({
                                          progress: currentProgress,
                                          isFlorist: data.isFlorist,
                                        }),
                                      );
                                    },
                                  });

                                const s3BucketUrl = `https://${process.env.REACT_APP_S3_BUCKET_URL}/${imagePath}`;
                                const updatedImage = {
                                  ...image,
                                  url: s3BucketUrl,
                                };
                                delete updatedImage.file;
                                return updatedImage;
                              } catch (error) {}
                            } else {
                              progresses.splice(index, 1, 100);
                              return image;
                            }
                          }),
                        )
                      : [];
                    resolve({ ...variation, imageDTOList: updatedImages });
                  });
                }),
              )
            : [];

          const [updatedImages, updatedVariations] = await Promise.all([
            updatedImagesPromise,
            updatedVariationsPromise,
          ]);
          data.floristInventoryImages = updatedImages;
          data.floristVariationDTOS = updatedVariations;

          const variationImages = updatedVariations
          ?.flatMap(variation => variation?.imageDTOList || []); 
          const combinedArray = [
            ...updatedImages,
            ...(Array.isArray(variationImages) && variationImages.length > 0 ? variationImages : [])
          ];
           const filteredArray = combinedArray.filter(item => !item?.id);

          const updatedCombinedArray = filteredArray.map((item) => ({
            imageDTO : {
              extension : item?.extension,
              fileName : item?.fileName,
              url : item?.url
            },
            imageCategory : {
              id : 81,
              name : 'Product Image'
            },
          }))

          const updatedPayload = {
            floristImagesDTOS: updatedCombinedArray,
            floristId: data.floristId ?? null,
          };

          const response2 = await baseQuery({
            url: 'vendor/api/floristImages',
            method: 'POST',
            body: { ...updatedPayload },
          });

          const response = await baseQuery({
            url: `${FLORIST_INVENTORY}`,
            method: 'POST',
            body: { ...data },
          });
          store.dispatch(
            setProductsProgress({
              uploading: false,
              isFlorist: true,
            }),
          );
          store.dispatch(resetProductsState());
          return { data: response.data?.objectData };
        } catch (error) {
          return { error };
        }
      },
      invalidatesTags: ['preLiveChecks'],
    }),
    updateFloristInventory: builder.mutation({
      query: (data) => ({
        url: `${FLORIST_INVENTORY}`,
        method: 'PUT',
        body: { ...data },
      }),
    }),
    bulkDeleteFloristInventory: builder.mutation({
      query: (data) => ({
        url: `${FLORIST_INVENTORY}/deleteByIds`,
        method: 'DELETE',
        body: { deleteIds: [...data] },
      }),
    }),
    bulkUpdateTopTags: builder.mutation({
      query: (data) => ({
        url: `${FLORIST_INVENTORY}/assignTags`,
        method: 'POST',
        body: { ...data },
      }),
      invalidatesTags: ['preLiveChecks'],
    }),
    getSingleFloristProduct: builder.query({
      query: (id) => ({
        url: `${FLORIST_INVENTORY}/${id}`,
      }),
    }),
    getSingleFloristProductDrawer: builder.query({
      query: (id) => ({
        url: `${FLORIST_INVENTORY_Drawer}/${id}`,
        method: 'GET',
      }),
    }),
    getSingleFloristProductById: builder.mutation({
      query: (id) => ({
        url: `${FLORIST_INVENTORY}/${id}`,
        method: 'GET',
      }),
    }),
    deleteFloristInventory: builder.mutation({
      query: (id) => ({
        url: `${FLORIST_INVENTORY}/${id}`,
        method: 'DELETE',
      }),
    }),
    postInventoryTag: builder.mutation({
      query: ({ body }) => ({
        url: 'inventory/invTag',
        method: 'POST',
        body: body,
      }),
      invalidatesTags: ['inventoryTags'],
    }),
    deleteInventoryTag: builder.mutation({
      query: ({ id }) => ({
        url: `inventory/invTag/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['inventoryTags'],
    }),
    uploadFloristInventoryImages: builder.mutation({
      query: ({ formData, inventoryId }) => ({
        url: `/inventory/api/floristInventory/v2/multiple/files`,
        method: 'POST',
        body: formData,
        params: { inventoryId },
      }),
    }),
    uploadInventoryImages: builder.mutation({
      query: ({ formData }) => ({
        url: `/inventory/inventory/v2/multiple/files`,
        method: 'POST',
        body: formData,
      }),
    }),
    uploadVariationImages: builder.mutation({
      query: ({ formData }) => ({
        url: `/inventory/api/floristInventory/variation/v2/multiple/files`,
        method: 'POST',
        body: formData,
      }),
    }),
    addProductToCatalogue: builder.mutation({
      query: (data) => ({
        url: `${FLORIST_INVENTORY}/contributeToCatalog`,
        method: 'POST',
        body: {
          inventoryDTOS: [data],
        },
      }),
    }),
    removeProductFromCatalogue: builder.mutation({
      query: (id) => ({
        url: `${FLORIST_INVENTORY}/removeFromCatalog/${id}`,
        method: 'POST',
      }),
    }),
    upVoteProduct: builder.mutation({
      query: (id) => ({
        url: `${PRODUCTS_URL}/upVote/${id}`,
        method: 'POST',
      }),
    }),
    downVoteProduct: builder.mutation({
      query: (id) => ({
        url: `${PRODUCTS_URL}/downVote/${id}`,
        method: 'POST',
      }),
    }),
    updateProductStatus: builder.mutation({
      query: (data) => ({
        url: `${FLORIST_INVENTORY}/activate-deactivate`,
        method: 'POST',
        body: { ...data },
      }),
    }),

    updateProductStockStatus: builder.mutation({
      query: (data) => ({
        url: `${FLORIST_INVENTORY}/stock-status`,
        method: 'POST',
        body: { ...data },
      }),
    }),

    /* Inventory Insights */
    getInventoryInsightsYearly: builder.mutation({
      query: ({ year }) => ({
        url: `${INVENTORY_INSIGHTS}/insights/yearly/kpis?year=${year}`,
        method: 'GET',
      }),
    }),
    getInventoryInsightsByFilter: builder.mutation({
      query: ({ filter }) => ({
        url: `${INVENTORY_INSIGHTS}/insights/sales/views/kpis?filter=${filter}`,
        method: 'GET',
      }),
    }),
    updateHolidayPricing: builder.mutation({
      query: (data) => ({
        url: `vendor/api/florist/settings/holiday/pricing`,
        method: 'POST',
        body: { ...data },
      }),
    }),
    getHolidayPricing: builder.query({
      query: () => ({
        url: `vendor/api/florist/settings/holiday/pricing/getByFloristId`,
      }),
      providesTags: ['HolidayPricing'],
      transformResponse: (responseData) => {
        return responseData?.objectData || [];
      },
    }),
    updateDiscountedPricing: builder.mutation({
      query: (data) => ({
        url: `vendor/api/florist/settings/discount/pricing`,
        method: 'POST',
        body: { ...data },
      }),
    }),
    getDiscountedPricing: builder.query({
      query: () => ({
        url: `vendor/api/florist/settings/discount/pricing/getByFloristId`,
      }),
      providesTags: ['DiscountedPricing'],
      transformResponse: (responseData) => {
        return responseData?.objectData || [];
      },
    }),
    getFloristListOfCatalogProducts: builder.query({
      query: () => ({
        url: `inventory/api/floristInventory/contributed/florist/list`,
        method: 'GET',
      }),
    }),
    getAllFloristForCatalogFilter: builder.query({
      query: () => ({
        url: `inventory/inventory/contributed/florist/list`,
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useAddProductMutation,
  useGetProductsQuery,
  useLazyGetProductsQuery,
  useLazyGetFloristInventoryQuery,
  useDeleteProductMutation,
  useGetProductsDropDownMutation,
  useGetSingleProductQuery,
  useDeleteBulkProductMutation,
  useBulkDeleteFloristInventoryMutation,
  useAddCatalogueMutation,
  useGetFloristInventoryQuery,
  useAddFloristInventoryMutation,
  useGetSingleFloristProductQuery,
  useUpdateFloristInventoryMutation,
  useDeleteFloristInventoryMutation,
  useBulkUpdateTopTagsMutation,
  usePostInventoryTagMutation,
  useDeleteInventoryTagMutation,
  useUploadFloristInventoryImagesMutation,
  useUploadInventoryImagesMutation,
  useUploadVariationImagesMutation,
  useGetSingleFloristProductByIdMutation,
  useGetSingleProductByIdMutation,
  useAddProductToCatalogueMutation,
  useRemoveProductFromCatalogueMutation,
  useUpVoteProductMutation,
  useDownVoteProductMutation,
  useUpdateProductStatusMutation,
  useGetInventoryInsightsYearlyMutation,
  useGetInventoryInsightsByFilterMutation,
  useGetSingleFloristProductDrawerQuery,
  useUpdateHolidayPricingMutation,
  useGetHolidayPricingQuery,
  useUpdateDiscountedPricingMutation,
  useGetDiscountedPricingQuery,
  useGetFloristListOfCatalogProductsQuery,
  useGetAllFloristForCatalogFilterQuery,
  useUpdateProductStockStatusMutation,
} = productsApiSlice;
